var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-wrapper"},[_c('swiper',{ref:"mySwiper",staticClass:"swiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',{staticClass:"slide-item"},[_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/swiper-02.png","alt":"","srcset":""}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }